export default defineNuxtPlugin(() => {
	const mixpanel = useMixpanel()
	mixpanel?.register({
		user_type: 'business',
		platform: 'web'
	})

	// Register biz_name once user data is available, skip if already set
	watch(
		() => useUser().User?.customer?.name,
		biz_name => {
			if (biz_name && mixpanel?.get_property('biz_name') !== biz_name) {
				mixpanel?.register({ biz_name })
			}
		},
		{ immediate: true }
	)
})
